import { render, staticRenderFns } from "./InvoiceDesign.vue?vue&type=template&id=df96371a&scoped=true&"
import script from "./InvoiceDesign.vue?vue&type=script&lang=js&"
export * from "./InvoiceDesign.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDesign.vue?vue&type=style&index=0&id=df96371a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df96371a",
  null
  
)

export default component.exports